import fetch,{postFrom} from '../utils/fetch';

// 资产列表
export function getAssetslist(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getAassetsList',
        data:params
    })
}

export function getCategoryTypeList(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getCategoryTypeList',
        data:params
    })
}

export function saveAssetsInfo(params) {
    return fetch({
        method: 'POST',
        url: 'assets/saveAssetsInfo',
        data:params
    })
}

export function updateAssetsInfo(params) {
    return fetch({
        method: 'POST',
        url: 'assets/updateAssetsInfo',
        data:params
    })
}

export function getAssetsInfoByFid(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getAssetsInfoByFid',
        data:params
    })
}

export function getAssetsProvidelist(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getAssetsProvidelist',
        data:params
    })
}


export function provideAssets(params) {
    return fetch({
        method: 'POST',
        url: '/assets/provideAssets',
        data:params
    })
}

export function deleteAssetsInfo(params) {
    return fetch({
        method: 'POST',
        url: '/assets/deleteAssetsInfo',
        data:params
    })
}

export function getAssetsPutList(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getAssetsPutList',
        data:params
    })
}

export function getProvideList(params) {
    return fetch({
        method: 'POST',
        url: '/assets/getProvideList',
        data: params
    })
}

export function getAssetsPutRecordList(params){
    return fetch({
        method: 'POST',
        url: '/assets/getAssetsPutRecordList',
        data: params
    })
}

export function saveAssetsPutRecordInfo(params){
    return fetch({
        method: 'POST',
        url: '/assets/saveAssetsPutRecordInfo',
        data: params
    })
}

export function getAssetsByAccetsCode(params){
    return fetch({
        method: 'POST',
        url: '/assets/getAssetsByAccetsCode',
        data: params
    })
}

export function getLikeCodeByAccetsCode(params){
    return fetch({
        method: 'POST',
        url: '/assets/getLikeCodeByAccetsCode',
        data: params
    })
}

export function getPersonNameByName(params){
    return fetch({
        method: 'POST',
        url: '/assets/getPersonNameByName',
        data: params
    })
}

